import { Component } from 'react'

import ModalLogIn from './ModalLogIn'
import ModalRegister from './ModalRegister'

import Button from '../../libs/ui/buttons/Button'
import User from '../../libs/user/User'


interface LoginRegisterState {
    logInIsOpen: boolean
    sigInIsOpen: boolean
}

interface LoginRegisterProps {
    isLogged: boolean
    isExpire: boolean
    showTitle?: boolean
    loggedOkCallBack: Function
    expiredSessionCallbak : Function
}

class LoginRegister extends Component<LoginRegisterProps, LoginRegisterState> {

    constructor (props: any) {
        super(props)

        this.state = {
            logInIsOpen: false,
            sigInIsOpen: false
        }

        this.openModalLogIn = this.openModalLogIn.bind(this)
        this.closeModalLogIn = this.closeModalLogIn.bind(this)
        this.openModalSigIn = this.openModalSigIn.bind(this)
        this.closeModalSigIn = this.closeModalSigIn.bind(this)

        this.callBackGoToLogIn = this.callBackGoToLogIn.bind(this)
        this.callBackGoToSigIn = this.callBackGoToSigIn.bind(this)
    }

    render () {
        const formClassName = (this.props.isExpire) ? 'is-invalid' : ''

        return ( !this.props.isLogged &&
            <>
                <div className='col-12'>
                    {this.props.showTitle &&
                        <p>
                            <span className="titleLev3 colorPrimaryBlue text-center">
                                Compila il modulo per ricevere un preventivo personalizzato gratuito
                            </span>
                        </p>
                    }
                    {/*
                    <div id='formLoginRegister' className={formClassName}>
                        <p className="titleLev4">
                            {
                                this.props.isExpire 
                                ? <>Sessione scaduta, ti preghiamo di ri autenticarti</>
                                : <>Ehi, per caso ci siamo già visti?</>
                            }
                        </p>
                        <p>
                            Inserisci il tuo indirizzo email&nbsp;
                            {
                                this.props.isExpire 
                                ? <>e autenticati nuovamente</>
                                : <>e crea la tua area personale</>
                            }. 
                            Seguire i tuoi preventivi sarà più facile!
                        </p>
                        <div className='d-flex align-items-center justify-content-center'>
                            <Button
                                id='logIn'
                                type='button'
                                className='btn btn-medium btn-primary'
                                onClick={this.openModalLogIn}
                            >
                                Accedi
                            </Button>
                            {!this.props.isExpire &&
                                <>
                                    <span className='spacer'>o</span>
                                    <Button
                                        id='sigIn'
                                        type='button'
                                        className='btn btn-medium btn-secondary'
                                        onClick={this.openModalSigIn}
                                    >
                                        Registrati
                                    </Button>
                                </>
                            }
                        </div>
                    </div>
                    */}
                </div>

                <ModalLogIn 
                    isOpen={this.state.logInIsOpen}
                    callBackToggle={this.closeModalLogIn}
                    callBackGoToSigIn={this.callBackGoToSigIn}
                />

                <ModalRegister 
                    isOpen={this.state.sigInIsOpen}
                    callBackToggle={this.closeModalSigIn}
                    callBackGoToLogIn={this.callBackGoToLogIn}
                />
            </>
        )
    }

    private callBackGoToSigIn () {
        this.setState({
            logInIsOpen: false,
            sigInIsOpen: true
        })
    }

    private callBackGoToLogIn () {
        this.setState({
            logInIsOpen: true,
            sigInIsOpen: false
        })
    }

    private openModalLogIn () {
        this.setState({
            logInIsOpen: true
        }, () => {
            this.props.expiredSessionCallbak(false)
        })
    }

    private closeModalLogIn (u?: User) {
        const usr = (!u) ? undefined : u

        this.setState({
            logInIsOpen: false
        }, () => {
            if (this.props.loggedOkCallBack) {
                this.props.loggedOkCallBack(usr)
            }
        })
    }

    private openModalSigIn () {
        this.setState({
            sigInIsOpen: true
        })
    }

    private closeModalSigIn () {
        this.setState({
            sigInIsOpen: false
        })
    }
}

export default LoginRegister